// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__15GKw","colMaxWidth":"Table_colMaxWidth__3m3M1"};